var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.nodes),function(node,i){return _c('message-body-node',{key:i,attrs:{"node":node,"created-at":_vm.createdAt}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }